import React from "react";
import { Box, Typography } from "@mui/material";
import { useLayoutConstants } from "@BehpardazBarin/frontend_components";
import { useLocation } from "react-router-dom";

const Footer: React.FC = () => {
  const { pathname } = useLocation();
  const { isMobile } = useLayoutConstants(pathname);
  return (
    <Typography
      variant="body2"
      component="div"
      mt={2}
      mb={2}
      textAlign="center"
      color="#00665A"
      sx={{
        fontSize: isMobile ? "12px" : "14px",
        fontFamily: "IRANSansX",
      }}
    >
      <Box sx={{ fontFamily: "IRANSansXBold" }}>تلفن پشتیبانی</Box>
      <br />
      <strong
        style={{
          fontSize: isMobile ? "14px" : "18px",
        }}
      >
        ۰۵۱۳۲۰۱۰۲۰۶ - ۰۵۱۳۲۰۱۰۲۰۷
      </strong>
      <br />
      <Box sx={{ textAlign: "center", my: 2 }}>
        <Typography variant="caption">{`نسخه ${process.env.REACT_APP_VERSION}`}</Typography>
      </Box>
    </Typography>
  );
};

export default Footer;
